(function () {
    'use strict';

    angular.module('app.controllers')
        .controller('StreamingVideoCtrl', StreamingVideoCtrl)
    ;

    /* @ngInject */
    function StreamingVideoCtrl(DataFactory, $rootScope) {

        var vm = this;

        vm.dataTypes = [
            {
                label: 'Chart',
                value: 'Chart'
            },
            {
                label: 'Table',
                value: 'Table'
            },
        ];
        vm.visibleType = vm.dataTypes[0];

        DataFactory.getTableData('streaming-video').then(function (allData) {

            var streamingVideo = {};
            var streamingVideoGender = {};
            var streamingVideoTotal = {};
            var source = {};

            angular.forEach(allData.rows, function (row) {
                var month = row.values[0];
                var demo = row.values[1];

                if (streamingVideo[month] === undefined) {
                    streamingVideo[month] = {
                        columns: allData.columns.slice(1),
                        rows: []
                    };

                    if ($rootScope.retroMonths.indexOf(month) !== -1) {
                        source[month] = 'Digital Content Ratings - ' + month;
                    } else {
                        source[month] = 'Digital Content Ratings, Video, ' + month + ', People 18+, Monthly Total';
                    }
                }

                if (streamingVideoGender[month] === undefined) {
                    streamingVideoGender[month] = []
                }

                if (streamingVideoTotal[month] === undefined) {
                    streamingVideoTotal[month] = []
                }

                var brandData = {
                    values: []
                };
                for (var i = 1; i < row.values.length; i++) {
                    brandData.values.push(row.values[i]);
                }
                streamingVideo[month].rows.push(brandData);

                if (demo.indexOf('Total Female 18+') === 0 || demo.indexOf('Total Male 18+') === 0) {
                    streamingVideoGender[month].push({
                        Category: brandData.values[0].replace('Total ', ''),
                        value: brandData.values[1].replace(/,/g,''),  // strip commas
                        reach: brandData.values[2],
                        time: brandData.values[3]
                    });
                }

                // All total values except Total 18+
                if (demo.indexOf('Total') === 0 && demo.indexOf('Total 18+') !== 0 && demo.indexOf('Female') === -1 && demo.indexOf('Male') === -1) {
                    streamingVideoTotal[month].push({
                        Category: brandData.values[0].replace('Total ', ''),
                        value: brandData.values[1].replace(/,/g,''),  // strip commas
                        reach: brandData.values[2],
                        time: brandData.values[3]
                    });
                }
            });

            vm.streamingVideo = streamingVideo;
            vm.streamingVideoGender = streamingVideoGender;
            vm.streamingVideoTotal = streamingVideoTotal;

            vm.source = source;
        });
    }

})();
